export enum AnalyticsEventName {
  PageView = 'PageView',
  ButtonPress = 'ButtonPress',
  WalletConnect = 'WalletConnect',
  WalletConnectStart = 'WalletConnectStart',
  WalletConnectError = 'WalletConnectError',
  GameStart = 'GameStart',
  EntryFinal = 'EntryFinal',
  MintStart = 'MintStart',
  MintError = 'MintError',
  MintSuccess = 'MintSuccess',
}
